// src/components/CourseSchedule.jsx
import React from "react";
import { Link } from "react-router-dom";

const CourseSchedule = ({ sessions }) => {
  return (
    <section className="py-12 px-4 bg-white">
      <h2 className="text-3xl font-bold text-blue-900 text-center mb-8">Schedule & Pricing</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {sessions.map((session, idx) => (
          <div key={idx} className="border rounded-xl p-6 shadow hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-blue-800 mb-2">{session.title}</h3>
            <p className="text-gray-700 text-sm mb-1"><strong>Date:</strong> {session.date}</p>
            <p className="text-gray-700 text-sm mb-1"><strong>Time:</strong> {session.time}</p>
            <p className="text-gray-700 text-sm mb-1"><strong>Location:</strong> {session.location}</p>
            <p className="text-gray-700 text-sm mb-3"><strong>Price:</strong> ${session.price}</p>
            <Link
  to={`/register?title=${encodeURIComponent(session.title)}&date=${encodeURIComponent(session.date)}&location=${encodeURIComponent(session.location)}&price=${session.price}`}
>
  <button className="bg-blue-700 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-800 transition">
    Register
  </button>
</Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CourseSchedule;
